import { format } from "date-fns";
import { Bookmark, Calendar, Clock } from "lucide-react";

import { EventType } from "@classview/shared-types";

import { EventAttendingBadge } from "./event-attending-badge";

type EventDetailsProps = {
  type: EventType;
  startAt: string;
  endAt: string;
  isAttending?: boolean;
};

export function EventDetails({
  type,
  startAt,
  endAt,
  isAttending,
}: EventDetailsProps) {
  const startTime = format(startAt, "HH:mm");
  const endTime = format(endAt, "HH:mm");
  const formattedDate = format(startAt, "eee, MMM d");
  const formattedType = type.toLowerCase();
  return (
    <dl className="flex flex-row flex-wrap items-center gap-x-4">
      <div className="flex items-center">
        <dt className="sr-only">Duration</dt>
        <dd className="flex items-center text-sm text-muted">
          <Clock
            className="mr-1 size-3 text-card-foreground"
            aria-hidden={true}
          />
          {`${startTime} - ${endTime}`}
        </dd>
      </div>
      <div className="flex items-center">
        <dt className="sr-only">Recording date</dt>
        <dd className="flex items-center text-sm text-muted">
          <Calendar
            className="mr-1 size-3 text-card-foreground"
            aria-hidden={true}
          />
          {formattedDate}
        </dd>
      </div>
      <div className="flex items-center">
        <dt className="sr-only">Type</dt>
        <dd className="flex items-center text-sm capitalize text-muted">
          <Bookmark
            className="mr-1 size-3 text-card-foreground"
            aria-hidden={true}
          />
          {formattedType}
        </dd>
      </div>
      {isAttending && <EventAttendingBadge />}
    </dl>
  );
}
